/* API module for PatientController */

import { api } from './http';
import { toApiError } from './errors';
import type {
  PatientCreateRequestDTO,
  PatientResponseDTO,
  PatientUpdateRequestDTO,
  PatientenfehlerResponseDTO,
} from './types';

export type Id = number;

export async function getAll(): Promise<PatientResponseDTO[]> {
  try {
    const { data } = await api.get<PatientResponseDTO[]>('Patient');
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function getById(id: Id): Promise<PatientResponseDTO> {
  try {
    const { data } = await api.get<PatientResponseDTO>(`Patient/${id}`);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function create(payload: PatientCreateRequestDTO): Promise<PatientResponseDTO> {
  try {
    const { data } = await api.post<PatientResponseDTO, PatientCreateRequestDTO>('Patient', payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function update(id: Id, payload: PatientUpdateRequestDTO): Promise<PatientResponseDTO> {
  try {
    const { data } = await api.put<PatientResponseDTO, PatientUpdateRequestDTO>(`Patient/${id}`, payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function remove(id: Id): Promise<void> {
  try {
    await api.delete<void>(`Patient/${id}`);
  } catch (e) {
    throw toApiError(e);
  }
}

export async function getFehler(id: Id): Promise<PatientenfehlerResponseDTO[]> {
  try {
    const { data } = await api.get<PatientenfehlerResponseDTO[]>(`Patient/${id}/fehler`);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function exportCsv(): Promise<Blob> {
  const token = localStorage.getItem('accessToken');
  const baseUrl = (import.meta as any).env?.VITE_API_BASE_URL || `${window.location.origin}/api`;
  const base = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  const url = new URL('Patient/export-csv', base.startsWith('http') ? base : `${window.location.origin}${base.startsWith('/') ? '' : '/'}${base}`);

  const resp = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (!resp.ok) {
    throw new Error(`Export fehlgeschlagen (HTTP ${resp.status})`);
  }

  return resp.blob();
}
